<template>
	<div>		
		1111111
	</div>
</template>
<script>
export default {

	data(){
		return {
			
		}
	},
	mounted(){
		
	},
	methods:{

	}
}
</script>